function getTypeOSnameById(typeOS){
  var typeOSList = {10:'PRODUTIVA', 11:'PRODUTIVA_MOVIMENTACAO', 12:'IMPRODUTIVA'}

  return typeOSList.hasOwnProperty(typeOS) ? typeOSList[typeOS] : typeOSList[1]
}

export function getTypeOSbyCode(typeOS){
  var typeOSList = {10:'BAIXA PRODUTIVA', 11:'BAIXA PRODUTIVA', 12:'BAIXA IMPRODUTIVA'}

  return typeOSList.hasOwnProperty(typeOS) ? typeOSList[typeOS] : typeOSList[1]
}

export function getTypeLow(typeOS, actionId) {

  if (typeOS == 10) { 
    return 1;
  }

  if (typeOS == 12) { 
    return 2;
  }

  if (typeOS == 11 && actionId == 1) { 
    return 5;
  }

  if (typeOS == 11 && actionId == 2) { 
    return 4;
  }

  if (typeOS == 11 && actionId == 3) { 
    return 3;
  }

}


export default getTypeOSnameById;